// extracted by mini-css-extract-plugin
module.exports = {"SmallTextModule":"SmallTextModule_SmallTextModule__NczQN"};